<template>
  <div
    v-if="tooltip"
    v-tooltip="tooltip"
    class="truncate-wrapper flex items-center space-x-2"
    @click="handleClick"
  >
    <span
      class="truncate text-sm"
      :class="disabled ? 'cursor-default' : 'cursor-pointer'"
      data-cy="text-display-with-clipboard"
    >
      {{ text }}
    </span>
    <icon-base
      v-if="icon"
      class="text-disabled-medium"
      :icon="icon"
      height="24"
      width="24"
    />
  </div>
  <div
    v-else
    v-tooltipable.collapsed="$t('COMMON.CLICK_TO_COPY')"
    class="truncate-wrapper flex items-center space-x-2"
    @click="handleClick"
  >
    <span
      class="truncate text-sm"
      :class="disabled ? 'cursor-default' : 'cursor-pointer'"
      data-cy="text-display-with-clipboard"
    >
      {{ text }}
    </span>
    <icon-base
      v-if="icon"
      class="text-disabled-medium"
      :icon="icon"
      height="24"
      width="24"
    />
  </div>
</template>

<script setup lang="ts">
import { useClipboardWithMessage } from "@/hooks/clipboard";

import IconBase from "@/components/ui/IconBase.vue";

import type { Component } from "vue";

const {
  icon,
  maxWidth = 255,
  text,
  value,
  disabled = false,
  tooltip,
} = defineProps<{
  icon?: Component;
  maxWidth?: number;
  text: string;
  value?: string;
  disabled?: boolean;
  tooltip?: string;
}>();

const copyToClipboard = useClipboardWithMessage();

const handleClick = () => {
  if (disabled) {
    return;
  }

  copyToClipboard(value ?? text);
};
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.truncate-wrapper {
  max-width: v-bind(maxWidth + "px");
  @apply truncate;
}
</style>
